"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var DataGridPagination_1 = __importDefault(require("../DataGridPagination"));
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var palette = _a.palette;
    return ({
        container: {
            borderBottom: "1px solid ".concat(palette.divider),
            borderTop: "1px solid ".concat(palette.divider)
        },
    });
});
var DataGridFooter = function (props) {
    var footerElement = props.footerElement, showPagination = props.showPagination, totalCount = props.totalCount, rowsPerPage = props.rowsPerPage, page = props.page, onChangePage = props.onChangePage, onChangeRowsPerPage = props.onChangeRowsPerPage;
    var classes = useStyles();
    return (react_1.default.createElement(Grid_1.default, { container: true, classes: { container: classes.container } },
        react_1.default.createElement(Grid_1.default, { item: true, sm: showPagination ? 6 : 12 }, footerElement),
        showPagination && (react_1.default.createElement(Grid_1.default, { item: true, sm: 6 },
            react_1.default.createElement(DataGridPagination_1.default, { totalCount: totalCount, rowsPerPage: rowsPerPage, page: page, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage })))));
};
exports.default = DataGridFooter;
